(function() {
'use strict';

angular
    .module('TR')
    .directive('navigationDrawerToggle', function(
        broker
    ) {
        return {
            restrict: 'A',

            link(scope, element) {
                scope.toggle = function() {
                    broker.publish('toggleNavigationDrawer');
                };

                element.on('click.navigationDrawerToggle', function(e) {
                    e.preventDefault();
                    scope.$apply(scope.toggle());
                });

                scope.$on('$destroy', function() {
                    // unbind jquery event listeners
                    element.off('click.navigationDrawerToggle');
                });
            }

        };
    });
})();
